<template
  ><div class="tel-input" :class="getContainerClass()">
    <div v-if="label" class="tel-input__label">
      {{ label }}
      <span v-if="required" class="tel-input__required">(Required)</span>
    </div>
    <vue-tel-input
      v-model="value"
      v-bind="bindProps"
      @input="emitValue"
      @validate="onValidate"
      @blur="onBlur"
      @focus="onFocus"
      :class="{
        ['focused']: isFocused,
        ['hovered']: hovered
      }"
    ></vue-tel-input>
    <div
      v-show="!isFocused"
      v-for="(error, idx) in errors"
      :key="idx"
      class="tel-input__error"
    >
      {{ error }}
    </div>
  </div></template
>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { VueTelInput } from "vue-tel-input";

import VSelect from "@/components/VSelect";
import VInput from "@/components/VInput";

export default Vue.component("VTelInput", {
  props: {
    label: VueTypes.string,
    required: VueTypes.bool.def(true),
    errors: VueTypes.array,
    value: VueTypes.string
  },

  components: { VSelect, VInput, VueTelInput },

  data() {
    return {
      bindProps: { dynamicPlaceholder: true },
      isFocused: false,
      hovered: false,
      isValid: false
    };
  },

  methods: {
    _toggleFocused() {
      this.isFocused = !this.isFocused;
    },

    emitValue(val) {
      this.$emit("input", val);
    },

    sendValidationEmit() {
      if (!this.isValid && this.value) {
        this.$emit("innerValidation", ["Invalid phone"]);
      }
    },

    onValidate(val) {
      this.isValid = val.isValid;
      this.sendValidationEmit();
    },

    onBlur() {
      this._toggleFocused();
      this.$emit("blur");
      this.sendValidationEmit();
    },

    onFocus() {
      this._toggleFocused();
      this.$emit("focus");
    },

    getContainerClass() {
      return {
        [this.layout]: true,
        [this.classType]: true,
        [this.extraClass]: true,
        ["has-error"]: this.errors.length
      };
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "tel-input";

.#{$ns}__label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  font-size: 15px;
  color: $main-text-color;
  font-family: "Lato-Bold", sans-serif;
  padding-bottom: 14px;
  padding-left: 8px;
}
.#{$ns}__required {
  font-size: 15px;
  font-family: Lato-Light, sans-serif;
}

.#{$ns}__error {
  text-align: left;
  font-size: 14px;
  padding-top: 7px;
  font-family: Lato-Light, sans-serif;
  color: $danger-color;
}

.#{$ns} /deep/ .vti__input {
  color: $main-text-color;
  font-size: 15px;
  height: 30px;

  &.disabled {
    background-color: #e6e6e6;
  }

  &:focus {
    outline: 0;
    border-color: $primary-color;
  }

  &::placeholder {
    font-family: "Lato-Light", sans-serif;
    font-style: italic;
    font-size: 15px;
    color: #979797;
  }
}

.#{$ns} /deep/ .vti__dropdown {
  position: unset;
  &:focus {
    outline: none;
  }
}

.#{$ns} /deep/ .vti__dropdown-list {
  width: calc(100% + 2px);
  @include customScrollbar();
  border-top: none;
  border-radius: 3px;
  &.below {
    top: 29px;
  }
}

.vue-tel-input {
  position: relative;
  transition: border-color 0.2s linear;
  &:hover,
  &:focus-within {
    border-color: $primary-color;
    box-shadow: none;
  }
}

.has-error {
  .vue-tel-input {
    border-color: $danger-color;
    &:focus-within {
      border-color: $primary-color;
    }
  }
  input {
    &,
    &:focus {
      border-color: $danger-color;
    }
    color: $danger-color;
  }
}
</style>
